<template>
  <b-card>
    <!-- <b-alert show variant="warning"
      >برای ثبت کالا در شپالینک باید درگاه اختصاصی داشته باشید. اطلاعات زیر را
      تکمیل کنید تا درگاه اختصاصی برای شما ایجاد شود</b-alert
    > -->
    <b-alert :show="errors.length > 0" variant="danger">
      <ul>
        <li v-for="x in errors" :key="x">{{x}}</li>
      </ul>
    </b-alert>
    <div class="row">
      <b-col sm="6" md="3">
        <b-form-group label="نام فروشگاه:">
          <b-form-input v-model="pgw.website_name"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="6" md="3">
        <b-form-group label="نام فروشگاه به انگلیسی:">
          <b-form-input v-model="pgw.website_en_name"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="6" md="3">
        <b-form-group label="دسته بندی خدمات:">
          <MDDropdown
              id="select_category"
              placeholder="دسته بندی"
              group="9"
              required
              v-model="pgw.mdid9_category"
          ></MDDropdown>
        </b-form-group>
      </b-col>
      <b-col  sm="6" md="3">
         <b-form-group label="نوع ارز:">
          <MDDropdown
              id="select_curency"
              placeholder="نوع ارز"
              group="12"
              required
              v-model="mdid12_money_type"
               @input="onChange($event)"
          ></MDDropdown>
        </b-form-group>
      </b-col>
    </div>
    <div class="row">
      <b-col   sm="6" md="4" v-if="show_wallet">
         <b-form-group label="انتخاب کیف پول:">
           <b-input-group >
            <template v-slot:append>
              <b-button
                  variant="success"
                  @click="showAddNewWallet"
              >جدید</b-button
              >
            </template>
            <b-form-select
            placeholder="کیف پول"
                :options="options"
                v-model="wallet_id"
            ></b-form-select>
            </b-input-group>
        </b-form-group>
      </b-col>
      <b-col   sm="6" :md="!show_wallet?'6':'4'">
        <b-form-group
            id="shepalink"
            :label="$route.query.type!='qrcode' ? 'لینک کوتاه شخصی:' : 'آدرس QRCode:'"
            label-for="shepalink-input-1"
        >
          <b-input-group class="mt-3">
            <template v-slot:append>
              <b-input-group-text>
                <strong v-if="!show_wallet" dir="ltr">she.pa/@</strong>
                <strong v-else dir="ltr">she.pa/en/@</strong>
              </b-input-group-text>
            </template>
            <b-form-input dir="ltr" v-model="pgw.shepalink"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col  sm="6" :md="!show_wallet?'6':'4'">
        <b-form-group
            id="shepalink"
            label="شماره حساب واریز وجه:"
            label-for="shepalink-input-1"
        >
          <b-input-group class="mt-3">
            <template v-slot:append>
              <b-button
                  variant="success"
                  @click="$bvModal.show('addcard-modal')"
              >جدید</b-button
              >
            </template>
            <b-form-select
                :options="userCards"
                v-model="pgw.bankId"
            ></b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
    </div>
    <b-row>
      <b-col>
        <b-button variant="success" @click="savePGW">ذخیره</b-button>
      </b-col>
    </b-row>
    <AddCard v-bind:afterdone="getaccounts"></AddCard>
    <b-modal
        ref="addwallet-modal"
        :title="walletModalTitle"
        style="justify-content: space-around"
        @ok="sendAddOrEditWalletRequest"
        ok-title="ذخیره"
        cancel-title="بازگشت"
      >
        <b-form>
          <b-alert variant="danger" :show="AddEdit_error.length > 0">
            <p v-for="x in AddEdit_error" v-bind:key="x">{{ x }}</p>
          </b-alert>
          <b-form-group
            id="input_wallet_name-group-1"
            label="نام کیف پول: "
            label-for="input_wallet_name-1"
          >
            <b-form-input
              id="input_wallet_name-1"
              required
              v-model="walletName"
              placeholder="عنوان "
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="mdid12_money_type-group-1"
            label="واحد پولی: "
            label-for="mdid12_money_type-1"
          >
            <MDDropdown
             type="dollar"
              v-bind:group="12"
              v-model="mdid12_money_type1"
            ></MDDropdown>
          </b-form-group>
        </b-form>
      </b-modal>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_WALLETS } from "@/core/services/store/wallets.module";
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";
import AddCard from "../BankCards/AddCard";
import sessionHelper from "../../helpers/sessionHelper";
export default {
  data() {
    return {
      shepaLink: null,
      errors: [],
      pgw: {},
      loading: false,
      curencyType: {},
      userCards: [],
      options: [],
      wallet_id:null,
      mdid12_money_type:null,
      show_wallet:false,
      walletModalTitle: null,
      AddEdit_error: [],
      walletName:null,
      mdid12_money_type1: null,
      settlement_error: [],
       settlement: {
        wallet_id: 0,
        user_card_id: 0,
        price: 0,
        wallet_name: "",
        cash: 0,
      },
    };
  },
  components: {
    AddCard,
    MDDropdown,
  },
  
  computed:{
    loadedWallets(){
     
      
      return this.$store.getters.loadedWallets;
       
         
    }
  },
  
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, this.$route.query.type!='qrcode'?[{ title: "درخواست درگاه شخصی" }]:[{ title: "درخواست QRCode" }]);
    let api="wallets"
    this.$store.dispatch(GET_WALLETS,api)
    this.getaccounts();
  },
  
  methods: {
    getaccounts() {
      this.pgw.shepalink = sessionHelper.getUser().mobile;
      // this.pgw.shepalink = this.pgw.shepalink.substr(
      //   0,
      //   this.pgw.shepalink.indexOf("@")
      // );
      httpHelper.getData("usercards").then((response) => {
        this.userCards = response.result.map((item) => {
          return {
            text: item.shaba_number,
            value: item.id,
          };
        });
      });
    },
    savePGW() {
      var send_data = {
        bankId: this.pgw.bankId,
        website: this.pgw.shepalink,
        website_name: this.pgw.website_name,
        website_en_name: this.pgw.website_en_name,
        mdid9_category: this.pgw.mdid9_category,
        mdid12_money_type : this.mdid12_money_type,
      };
      !this.show_wallet ? Object.assign(send_data,{'wallet_id':this.wallet_id}) : '';
      httpHelper.postData("userconf/bandp", send_data).then((res) => {
        //this.getShepalink();
        if (res.success == true) {
           this.$makeToast('success','ارسال موفق',"درگاه شما با موفقیت ثبت شد.",5000)
          this.$router.push("gateways");
        } else {
          this.errors = [];
          for (const key in res.error) {
            if (Object.hasOwnProperty.call(res.error, key)) {
              const element = res.error[key];
              this.errors.push(element[0]);
            }
          }
        }
      });
    },
    onChange(e){
      if(e==483){
        this.show_wallet=false;
        this.options=[]
      }else{
        this.show_wallet=true;
        this.createOption(this.loadedWallets);
      }
    },
    createOption(option){
    option= option.filter(v=>v.md12_title==="دلار");
      this.options=[];
      let opt={};
      option.forEach(element => {
        Object.assign(opt,{"value":element.id,"text":element.wallet_name})
        this.options.push(opt);
        opt={};
      });
    },
    showAddNewWallet: function () {
      this.walletModalTitle = "اضافه کردن کیف پول جدید";
      this.showWalletModal();
    },
    showWalletModal() {
      this.$refs["addwallet-modal"].show();
    },
     sendAddOrEditWalletRequest(event) {
      event.preventDefault();
      if (this.loading) {
        return;
      }
      if (this.walletName == "" || this.walletName == null) {
        this.AddEdit_error.push("نام کیف پول را وارد کنید");
        return;
      }
      this.loading = true;
      httpHelper.setAuth();

      let walletData = {
        wallet_name: this.walletName,
        mdid12_money_type: this.mdid12_money_type1,
      };

      if (this.isInEditMode) walletData.id = this.walletId;

      httpHelper.postData("wallets", walletData).then((response) => {
       
      if (response.success === true) {
          httpHelper
            .getData("wallets")
            .then((response) => {
             this.createOption(response.result)
              this.hideWalletModal();
              this.loading = false;
            })
            .finally(() => {});
        }
   
    
      });

    },
    
    hideWalletModal: function () {
      this.$refs["addwallet-modal"].hide();
    },
  },
};
</script>